export enum Constants {
    ADD_ERROR= 'ADD_ERROR',
    CLEAR_ERROR= 'CLEAR_ERROR'
}
